const ToolsIcon = () => `<svg width="100%" height="100%" viewBox="0 0 24 24" fill="currentColor">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M15 9C16.1046 9 17 8.10457 17 7C17 5.89543 16.1046 5 15 5C13.8954 5 13 5.89543 13 7C13 8.10457 13.8954 9 15 9ZM15 11C13.1362 11 11.5701 9.72523 11.126 8H1V6H11.126C11.5701 4.27477 13.1362 3 15 3C16.8638 3 18.4299 4.27477 18.874 6H23V8H18.874C18.4299 9.72523 16.8638 11 15 11ZM12.874 16H23V18H12.874C12.4299 19.7252 10.8638 21 9 21C7.13616 21 5.57006 19.7252 5.12602 18H1V16H5.12602C5.57006 14.2748 7.13616 13 9 13C10.8638 13 12.4299 14.2748 12.874 16ZM11 17C11 18.1046 10.1046 19 9 19C7.89543 19 7 18.1046 7 17C7 15.8954 7.89543 15 9 15C10.1046 15 11 15.8954 11 17Z"
  />
</svg>`;
export default ToolsIcon;
